import { render, staticRenderFns } from "./ClientTable.vue?vue&type=template&id=6fcac73c&scoped=true&"
import script from "./ClientTable.vue?vue&type=script&lang=ts&"
export * from "./ClientTable.vue?vue&type=script&lang=ts&"
import style0 from "./ClientTable.vue?vue&type=style&index=0&id=6fcac73c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcac73c",
  null
  
)

export default component.exports